export default function checkJustNumber(number: any) {

    let numberString = String(number)

    if (numberString.replace(/[-]/g, "") === "") return true
    return new RegExp(/^[0-9]*$/).test(numberString.replace(/[-]/g, ""))
}
